// extracted by mini-css-extract-plugin
export default {"button":"Kl-z","reviewSort":"Ll-z"};